import * as Yup from 'yup'

const UpdatePackingSchema = Yup.object().shape({
  pickup_at: Yup.date()
    .nullable(true),
  invoice_done: Yup.boolean()
    .default(false),
  polaroid_done: Yup.boolean()
    .default(false),
  love_letter_done: Yup.boolean()
    .default(false),
  ready_to_ship: Yup.boolean()
    .default(false)
    .required('Required'),

  cart_item_updates: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number()
          .integer()
          .required('Required'),
        authenticity_check_done: Yup.boolean()
          .default(false),
        note_done: Yup.boolean()
          .default(false),
      })
    )
    .min(1, 'At least one product must be selected')
    .required('Items are required'),
})

export default UpdatePackingSchema
